import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ExtraService } from '../models/extra-service.model';
import { environment } from '../../../environments/environment';

/**
 * DRF-эндпоинт возвращает пагинацию (`{count, results, ...}`),
 * а сам метод разворачивает её в `ExtraService[]`. Если когда-нибудь
 * endpoint переключится на непагинированный массив — обработает и его
 * (см. fallback в `map`).
 */
@Injectable({ providedIn: 'root' })
export class ExtraServiceService {
  private apiUrl = `${environment.apiUrl}/booking/extra-services/`;

  constructor(private http: HttpClient) {}

  list(activeOnly = true): Observable<ExtraService[]> {
    let params = new HttpParams();
    if (activeOnly) {
      params = params.set('is_active', 'true');
    }
    return this.http.get<any>(this.apiUrl, { params }).pipe(
      map((res) => {
        if (res && Array.isArray(res.results)) {
          return res.results as ExtraService[];
        }
        if (Array.isArray(res)) {
          return res as ExtraService[];
        }
        return [] as ExtraService[];
      }),
    );
  }
}
